import { render } from "./AIRecommendationsContent.vue?vue&type=template&id=24ff7643&scoped=true"
import script from "./AIRecommendationsContent.vue?vue&type=script&lang=js"
export * from "./AIRecommendationsContent.vue?vue&type=script&lang=js"

import "./AIRecommendationsContent.vue?vue&type=style&index=0&id=24ff7643&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24ff7643"]])

export default __exports__